import { isString } from '../../utils/is-string';
import { PipeObject, Token } from '../types';

// TODO: add multiple if statements?? (if === a || if === b)

type IfSection = {
  start: number;
  end: number;
  statement?: string;
  isDefault?: boolean;
  ifStatementStart?: number;
  ifStatementEnd?: number;
  isIfStatementTrue?: boolean;
};

export const IfStatement = () => {
  return ({ input, lex, data }: PipeObject) => {
    let obj: Token;
    let ifSections: IfSection[] = [];
    let ifPos;
    // get all if statement sections
    while ((obj = lex.next())) {
      if (obj.token === 'if_start') {
        if (ifPos === undefined) {
          // this is our first if_start, mark it!
          ifPos = obj;
        } else if (ifPos !== undefined) {
          // we previously had an if_start, add that one to the list
          ifSections.push({ start: ifPos.begin, end: obj.begin - 1 });
          ifPos = obj;
        }
      } else if (obj.token === 'if_end') {
        ifSections.push({ start: ifPos.begin, end: obj.end });
        break;
      }
    }

    if (ifSections.length === 0) return { input, lex, data };

    // loop through each if section, and start doing math
    for (const ifSection of ifSections) {
      // get start/end of if section
      const { start, end } = ifSection;

      // reset scanner to start of if section
      lex.seek(start);
      let ifStartBegin, ifStartEnd;
      while ((obj = lex.next())) {
        // mark start of {{#if
        if (obj.token === 'if_start' && ifStartBegin === undefined)
          ifStartBegin = obj.end;
        // mark end of }}
        if (obj.token === 'mustache_end' && ifStartEnd === undefined)
          ifStartEnd = obj.begin;
        // stop once we get to end of if section
        if (obj.end === end) break;
      }

      // build the if statement
      const ifStatement = input.substring(ifStartBegin, ifStartEnd).trim();
      // check if if statement has `default`
      const isDefault = ifStatement === 'default';
      // where {{#if starts
      ifSection.ifStatementStart = ifStartBegin;
      // where }} ends
      ifSection.ifStatementEnd = ifStartEnd;
      // full if statement
      ifSection.statement = ifStatement;
      ifSection.isDefault = isDefault;

      // if isdefault no further eval needed
      if (ifSection.isDefault) continue;

      // eval statements and see if we have a match
      // split ifStatement into 3 sections
      // left = data object name
      // middle = operator
      // right = value it should equal
      const splitIfStatement = ifStatement.split(' ');
      let leftStatementReplacedByData = splitIfStatement[0]
        ?.trim()
        ?.split('.')
        ?.reduce((o, i) => o && o[i], data);
      leftStatementReplacedByData = isString(leftStatementReplacedByData)
        ? `"${leftStatementReplacedByData}"`
        : leftStatementReplacedByData;

      const isIfStatementTrue = eval(
        `${leftStatementReplacedByData} ${splitIfStatement[1]} ${splitIfStatement[2]}`
      );
      ifSection.isIfStatementTrue = isIfStatementTrue;

      // if ifstatement is true, don't process remaining if sections
      if (isIfStatementTrue) break;
    }

    // get true if section, or default section
    const ifStatementResult =
      ifSections.find((x) => x.isIfStatementTrue) ||
      ifSections.find((x) => x.isDefault);
    const ifStart = ifSections[0].start;
    const ifEnd = ifSections[ifSections.length - 1].end;
    // if no if statements matched, then remove all of {{#if}} {{/if}} statement
    if (!ifStatementResult) {
      return {
        input: input.replace(input.substring(ifStart, ifEnd + 1), ''),
        lex,
        data,
      };
    }

    // replace if statements
    let ifSectionReplaced = input.substring(
      ifStatementResult.start,
      ifStatementResult.end + 1
    );
    ifSectionReplaced = ifSectionReplaced.replace('{{/if}}', '');
    ifSectionReplaced = ifSectionReplaced.replace(
      input.substring(
        ifStatementResult.start || 0,
        (ifStatementResult.ifStatementEnd || 0) + 2
      ),
      ''
    );
    const finalResult =
      input
        .replace(input.substring(ifStart, ifEnd + 1), ifSectionReplaced)
        .trim() + '\n';

    return { input: finalResult, lex, data };
  };
};
